


































































import EditionModal from "../core/Modals/EditionModal.vue";
import { AvisDeVirementApi } from "../api/AvisDeVirementApi";
import { AvisDeVirement } from "../models/AvisDeVirement";
import { UserApi } from "../api/UserApi";
import { User } from "../models/User";
import AvisDeVirementModalEdit from "./AvisDeVirementModalPartials/AvisDeVirementModalEdit.vue";
import AvisDeVirementModalDisplay from "./AvisDeVirementModalPartials/AvisDeVirementModalDisplay.vue";
import AvisDeVirementModalPdfViewer from "./AvisDeVirementModalPartials/AvisDeVirementModalPdfViewer.vue";

export default {
    name: "AvisDeVirementModal",
    components: {
        EditionModal,
        AvisDeVirementModalEdit,
        AvisDeVirementModalDisplay,
        AvisDeVirementModalPdfViewer,
    },
    props: {
        avisDeVirementId: Number,
        isNew: Boolean,
        forceEditing: Boolean,
    },
    data() {
        return {
            showModal: false,
            avisDeVirement: null,
            fetching: true,
            editing: false,
            AvisDeVirementApi: new AvisDeVirementApi(),
            UserApi: new UserApi(),
            editable: true,
            showPdfInEditMode: false,
        };
    },
    created() {
        var self = this;

        self.UserApi.getCurrentUser().then(function (user) {
            self.editable = !user.hasRole(User.ERole.Syndic);
        });
    },
    watch: {
        avisDeVirementId: function (newVal): void {
            var self = this;

            self.showModal = _.isNumber(newVal);
            if (self.showModal) {
                self.fetching = true;
                // Les lignes doivent être chargées avant toute sauvegarde :
                // serialize() les renvoie et le serveur les synchronise.
                self.AvisDeVirementApi.get(self.avisDeVirementId, {
                    include: "files,client,lignes",
                }).then(function (res) {
                    self.avisDeVirement = res;
                    self.fetching = false;
                });
            }
        },
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.avisDeVirement = new AvisDeVirement({});
                    this.creationModal();
                }
            },
        },
        forceEditing: function (newVal) {
            this.editing = newVal;
        },
    },
    methods: {
        closeModal: function (data): void {
            this.editing = false;
            this.showModal = false;
            this.$emit("close-modal", data);
        },
        saveAvisDeVirement: function (): Promise<AvisDeVirement> {
            var self = this;
            return self.AvisDeVirementApi.save(self.avisDeVirement).then(
                function (res) {
                    self.$emit("data-saved", self.avisDeVirement);
                    return res;
                }
            );
        },
        creationModal: function (): void {
            this.showModal = true;
            this.fetching = false;
            this.editing = true;
        },
        togglePdfVisibility: function (): void {
            this.showPdfInEditMode = !this.showPdfInEditMode;
        },
    },
};
